import React, { MouseEvent, useState } from "react"

import { SvgIconComponent } from "@mui/icons-material"
import { SvgIconProps } from "@mui/material/SvgIcon/SvgIcon"
import { styled } from "@mui/material/styles"

interface IProps extends SvgIconProps {
  icon: SvgIconComponent,
  onClick?: (event: MouseEvent) => void,
  disabled?: boolean,
  focusColor?: string
}

export const ActionIcon = ({ icon, onClick, focusColor, ...props }: IProps) => {
  const [activated, setActivated] = useState<boolean>(false)

  const StyledIcon = styled(icon)(({ color }) => ({
    cursor: "pointer",
    fontSize: "18px",
    color: activated ? focusColor : "",
    pointerEvents: props.disabled ? "none" : "inherit",

    ...color === "error" && error
  }))

  const onClickHandler = (event: MouseEvent) => {
    onClick?.(event)

    if (focusColor) {
      setActivated(true)
    }
  }

  const deactivateHandler = () => {
    setActivated(false)
  }

  return <StyledIcon
    onClick={onClickHandler}
    onMouseLeave={deactivateHandler}
    {...props} />
}

const error = {
  color: "#DF4C47"
}
